import { DEFAULTS } from "./defaults";
import { COLLAPSIBLE_LIST_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginCollapsibleList = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: COLLAPSIBLE_LIST_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginCollapsibleList
};
//# sourceMappingURL=viewer-loadable.js.map
